const config = {
  apiKey: "AIzaSyB_R0p5IvCGoQQY4-FDK-2i5FUgcuWLeq4",
  authDomain: "tradingapp-9cb8c.firebaseapp.com",
  databaseURL: "https://tradingapp-9cb8c.firebaseio.com",
  projectId: "tradingapp-9cb8c",
  storageBucket: "tradingapp-9cb8c.appspot.com",
  messagingSenderId: "244802319727"
};
export default config;
